export const claimsData = [
    { percentage: 84, copy: "Are hitting their workout goals", pathDesk: "M35,154 A85,85 0 1,1 169,97", pathMob: "M31,131 A72,72 0 1,1 144,83" },
    { percentage: 82, copy: "Are sticking to their fitness routine.", pathDesk: "M35,154 A85,85 0 1,1 170,89", pathMob: "M31,131 A72,72 0 1,1 145,76" },
    { percentage: 80, copy: "Have noticed an increase in muscle mass.", pathDesk: "M35,154 A85,85 0 1,1 170,81", pathMob: "M31,131 A72,72 0 1,1 145,69" },
    { percentage: 84, copy: "Feel Gainful has improved their overall health.", pathDesk: "M35,154 A85,85 0 1,1 169,97", pathMob: "M31,131 A72,72 0 1,1 144,83" },
];

export const СircularProgressBarStyle = {
    svgBorder: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      transform: "rotateY(0deg) rotateZ(126deg)",
      overflow: "visible",
      zIndex: "0",
    },
    svgOuter: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      transform: "rotateY(0deg) rotateZ(126deg)",
      overflow: "visible",
      zIndex: "1",
    },
    svgInner: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      transform: "rotateY(0deg) rotateZ(126deg)",
      overflow: "visible",
      zIndex: "2",
    },
    svgCircle: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      transform: "rotateY(0deg) rotateZ(0deg)",
      overflow: "visible",
      zIndex: "3",
    },
};
  
export const mockProducts = [
    {name: "Personalized Protein Powder",
    starting: 45,
    descr: "Formulated with simple and effective ingredients that work for you based on your diet, body composition and lifestyle habits, our protein formulas help you achieve a wide range of fitness goals, from weight loss to building muscle.",
    lines: [
        "Contains all 9 essential amino acids to benefit your whole body", 
        "19g to 27g of protein per serving to support muscle performance and recovery",
        "Whey, Keto, and plant-based formulas to fit your dietary needs",
        "No gluten, soy, fillers or artificial flavors, dyes or sweeteners"
    ],
    link: "/product/protein",
    },
    {name: "Pre-Workout",
    starting: 26,
    descr: "Your Personalized Pre-Workout blend is designed to maximize endurance and minimize recovery time, making your workouts more impactful.",
    lines: [
        "Formulated with caffeine, L-Theanine, L-Citrulline, Beta Alanine and BCAAs to fuel your workout and supercharge your recovery", 
        "2 refreshing flavors: Sour Watermelon and Strawberry Lemonade",
    ],
    link: "/product/preworkout",
    },
    {name: "Personalized Hydration",
    starting: 30,
    descr: "Perform at your best with hydration formulas that deliver an effective amount of electrolytes based on your workout frequency, intensity, and sweat levels.",
    lines: [
        "High-performance formula of 4 electrolytes and cane sugar to hydrate faster than water alone", 
        "21 convenient single-serve packs—just add to 8-16oz of water",
        "Caffeinated option contains 150mg of caffeine and 250mg of L-Theanine for a jitter-free, clean energy boost",
        "2 refreshing flavors: Lemon-Lime and Strawberry Lemonade",
        "Non-GMO and 100% plant-based, with no artificial flavors, colors, or sweeteners"
    ],
    link: "/product/hydration",
    },
    {name: "Creatine",
    starting: 22,
    descr: "Engineered for all types of athletes — it supports muscle strength, short energy bursts, aids in recovery, and may increase lean body mass.",
    lines: [
        "Reduces muscle soreness and aids in recovery", 
        "Supports interval training and enables you to break away from the pack",
        "Supports cognitive function",
    ],
    link: "/product/boosts",
    },
    {name: "Collagen",
    starting: 22,
    descr: "Contrary to popular belief, it does a lot more than simply growing healthier hair and stronger nails. Collagen promotes elasticity, strengthens connective tissues (e.g., tendons, ligaments, cartilage), and supports muscle recovery.",
    lines: [
        "A combination of amino acids that supports connective tissues", 
        "Scientist-recommended dosage supports immune function and collagen absorption",
        "Grass-fed, non-GMO, gluten-free, dairy-free, no sugar added, nothing artificial",
    ],
    link: "/product/boosts",
    },
    {name: "Fiber",
    starting: 22,
    descr: "Whole-body health starts in your gut. Fiber supports nutrient absorption, satiation, healthy regularity, and ease of eliminations. Ours is formulated with a scientist-recommended dosage of beta glucan — a heart-healthy soluble fiber derived from oats.",
    lines: [
        "Supports digestion and a healthy microbiome", 
        "Keeps you feeling full and reduces cravings",
        "Prebiotic fibers help support absorption of key minerals",
    ],
    link: "/product/boosts",
    },
]

export const usStates = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "DC",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
    "AA",
    "AP",
    "AE",
    "AS",
    "GU",
    "MP",
    "PR",
    "UM",
    "VI",
    "AB",
    "BC",
    "MB",
    "NB",
    "NL",
    "NS",
    "ON",
    "PE",
    "QC",
    "SK",
    "NT",
    "NU",
    "YT"
]

export const iAmData = [
    "Gym/Studio", 
    "Fitness Professional",
]

export const formDetails = {
comission: [
    {
        title: "Conversion action",
        copy: "Online purchase with processed valid payment"
    },
    {
        title: "Cookie days",
        copy: "30 day(s)"
    },
    {
        title: "Commission Type",
        copy: "Dollar amount of Sale/Redemption"
    },
    {
        title: "Base commission",
        copy: "$30.00/redemption"
    },
    {
        title: "Terms & Conditions",
        copy: "Personal orders do not qualify for commission and will not be included in payment history. *Payment is made 30 days after conversion occurs and any orders that are returned will not be eligible for commission. *Commission will be approved and paid out for first time subscription products for orders successfully submitted with your Personal Trainer Promo Code at checkout or if the customer purchased the order by clicking on your Personal Trainer referral link. *For subscription products, commission will be applied to the first subscription order only. Commissions will not be paid on recurring subscription products. *If the order was not submitted with your Personal Trainer Promo Code you will not be paid out commission unless the Personal Trainer referral link was used. *Commission will not be approved if you violate the terms and conditions of the program."
    },
],
business: [
    {
        title: "Application Requirements:",
        copy: ["-You must have an Instagram account.",
        "-You must be over 18 years of age to join our program.",
        "-You must be based in the United States or Canada."]
    },
    {
        title: "Promo Code Guidelines:",
        copy: ["-Min 5 characters, Max 16 characters",
         "-No use of 'Gainful'",
         "-Cannot resemble a specific Gainful promo code",
         "-No spaces",
         "-No special characters ($,%,/,@, etc...)",
         "-No inappropriate language",
         "-Code must be unique",
        ]
    },
    {
        title: "Contact:",
        copy: ["-For help, please contact us directly at _affiliates@gainful.com. "]
    },
    ]
}

export const errorMessages = {
    programagreed: ["", "You have to agree to Terms and Conditions"],
    iseighteen: ["", "You have to be at least 18 years old"],
    email: ["", "This field is required", "Email is not correct"],
    paypal: ["", "This field is required", "Email is not correct"],
    promo: ["", "This field is required", "Min character count is 5", "Max character count is 16", "No special characters ($,%,/,@, etc...)", "", "Promo code already taken" ]
    // promo: ["", "This field is required", "Min character count is 5", "Max character count is 16", "No special characters ($,%,/,@, etc...)", "free", "Promo code already taken" ]

}

export const regexp = {
    email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/,
    promo: /^[a-zA-Z0-9]{5,16}$/,
    paypal: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/,
};

export const specCharacters = [
    " ",
    "!",
    '”',
    "#",
    "$",
    "%",
    "&",
    "’",
    "(",
    ")",
    "*",
    "+",
    ",",
    "-",
    ".",
    "/",
    ":",
    ";",
    "<",
    "=",
    ">",
    "?",
    "@",
    "[",
    "\\",
    "]",
    "^",
    "_",
    "`",
    "{",
    "|",
    "}",
    "~",
]

export const perks = [
    "Receive a $30 commision for each customer you sign up",
    "Get 30% off all Gainful products",
    "Be the first to try new Gainful products",
    "Gain access to Gainful’s network of Personal Trainers",
]

export const howItWorks = [
    {
        title: "Sign Up FOR OUR PROGRAM",
        copy: 'Sign up for our Personal Trainer Program using the "Get Started" button below. Enter your information in all the required fields.',
    },
    {
        title: "SHARE THE LOVE",
        copy: 'We will provide you with a unique link and promo code that you can share with your community, giving them 30% off their first order at Gainful.com.',
    },
    {
        title: "GET REWARDED",
        copy: 'For every sale referred by you, you will earn $30 commission, with the potential to earn more on new and promotional products.',
    },    
]
